import { render, staticRenderFns } from "./FormCreateSponsor.vue?vue&type=template&id=12c87555&"
import script from "./FormCreateSponsor.vue?vue&type=script&lang=js&"
export * from "./FormCreateSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports